import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { SubdirectoryArrowRight } from '@mui/icons-material';
import ReRunSelectionBox from '../ProjectLog/ReRunSelectionBox';
import OpenExistingSession from './OpenExistingSession';
import './TopGrid.css';

function TopGrid({
  sessionData,
  projectId,
  sessionId,
  isTest,
  setLoadReRun,
  isLatestRun,
  setIsLatestRun,
  reRuns,
  setSessionData,
}) {
  return (
    <Grid container className="info-only-container">
      {reRuns !== null && reRuns.length > 0 && (
        <Grid item xs={12} className="info-container">
          <Grid container spacing={1}>
            <Grid item className="info-item">
              <SubdirectoryArrowRight className="session-arrow margin-default" />
              <ReRunSelectionBox
                reRuns={reRuns}
                session={sessionData}
                setSession={setSessionData}
                isLatestRun={isLatestRun}
                setIsLatestRun={setIsLatestRun}
                calculateTimeElapsed={a => {
                  return a;
                }}
                setLoadReRun={setLoadReRun}
                isProgressView={true}
              />
            </Grid>
          </Grid>
        </Grid>
      )}

      {sessionData.existingSessionIdRanFrom && (
        <OpenExistingSession
          sessionId={sessionData.existingSessionIdRanFrom}
          projectId={projectId}
          InfoContainer={({ children }) => <Grid className="info-container">{children}</Grid>}
        />
      )}
    </Grid>
  );
}

TopGrid.propTypes = {
  sessionData: PropTypes.object.isRequired,
  projectId: PropTypes.string.isRequired,
  sessionId: PropTypes.string.isRequired,
  isTest: PropTypes.bool,
  setLoadReRun: PropTypes.func.isRequired,
  isLatestRun: PropTypes.bool.isRequired,
  setIsLatestRun: PropTypes.func.isRequired,
  reRuns: PropTypes.array,
  setSessionData: PropTypes.func.isRequired,
};

export default TopGrid;
